import { InjectionToken } from '../../injection';

import { AuthGrantType } from '../services/auth-token-grant';

export interface IApiEndpointInformation {
  /**
   * Option to skip adding the `api/$VERSION` prefix to the API endpoint path.
   * Default: false
   */
  noPrefix?: boolean;
  /**
   * Allow control over the authentication type.
   * Default: password
   */
  grantType?: AuthGrantType;
}

export const API_ENDPOINT_INFORMATION_RECORDS: InjectionToken<Record<string, IApiEndpointInformation>[]>
  = new InjectionToken<Record<string, IApiEndpointInformation>[]>('API_ENDPOINT_INFORMATION_RECORDS');
